import * as tslib_1 from "tslib";
import { Utils } from 'cc-common';
import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../../_models/user-name-display-result-dto';
const ɵ0 = () => Date, ɵ1 = () => Date, ɵ2 = () => UserNameDisplayResultDto, ɵ3 = () => Date, ɵ4 = () => Date, ɵ5 = () => Date, ɵ6 = () => Date, ɵ7 = () => UserNameDisplayResultDto;
export class WorkflowSearchResultDto {
    get dashboardResponsibleUsersDisplayText() {
        return !!this.dashboardResponsibleUsers
            ? this.dashboardResponsibleUsers.map((r) => r.displayName).join(', ')
            : '';
    }
    get addedByUsersDisplayText() {
        return Utils.notNullAndDefined(this.addedBy) ? this.addedBy.displayName : null;
    }
    get workOrderIds() {
        return Utils.notNullAndDefined(this.workOrders) ? this.workOrders.split(',') : [];
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Date)
], WorkflowSearchResultDto.prototype, "invoiceDate", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Date)
], WorkflowSearchResultDto.prototype, "datePosted", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Array)
], WorkflowSearchResultDto.prototype, "dashboardResponsibleUsers", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", Date)
], WorkflowSearchResultDto.prototype, "inboxDate", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    tslib_1.__metadata("design:type", Date)
], WorkflowSearchResultDto.prototype, "dueDate", void 0);
tslib_1.__decorate([
    Type(ɵ5),
    tslib_1.__metadata("design:type", Date)
], WorkflowSearchResultDto.prototype, "startDate", void 0);
tslib_1.__decorate([
    Type(ɵ6),
    tslib_1.__metadata("design:type", Date)
], WorkflowSearchResultDto.prototype, "communityTerminationDate", void 0);
tslib_1.__decorate([
    Type(ɵ7),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], WorkflowSearchResultDto.prototype, "addedBy", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7 };
